<template>
  <div class="m-t-30">
    <!-- Container-fluid starts-->
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <div class="card shadow-none">
            <b-button v-if="prevBtn" @click="prevBtn(imageId)" class="RightSidebar_PrevBtn" variant="outline-dark"><i
                class="fa fa-chevron-left"></i></b-button>
            <b-button v-if="nextBtn" @click="nextBtn(imageId)" class="RightSidebar_NextBtn" variant="outline-dark"><i
                class="fa fa-chevron-right"></i></b-button>
            <div class="card-body">
              <div class="row">
                <div class="col-xl-12 col-md-12 my-gallery gallery">
                  <div class="form-group">
                    <h6>{{ $t("lbl_EMPBE_UploadVideo") }}</h6>
                    <b-form-file class="mb-2" v-model="videoModel" @change="handleFileUpload($event)" accept="video/*"
                      ref="videoupload" :placeholder="$t('lbl_EMPBE_InputFile_Placeholder')"
                      :browse-text="$t('lbl_EMPBE_InputFile_BrowseText')"
                      :no-drop-placeholder="$t('lbl_EMPBE_InputFile_NoDropPlaceholder')"
                      :drop-placeholder="$t('lbl_EMPBE_InputFile_DropPlaceholder')"></b-form-file>

                    <!-- <input class="form-control" type="file" accept="video/*"
                                            @change="handleFileUpload($event)" ref="videoupload"/> -->
                    <video @loadedmetadata="logDuration" ref="videoPlayer" id="video-preview" controls style="width: 100%"
                      :src="myvideoSrc" v-show="myvideoSrc" crossOrigin="anonymous" />
                    <br />
                    <b-button variant="outline-primary" @click="capture()" v-show="myvideoSrc">{{
                      $t("lbl_EMPBE_CapAsVideoCover") }}</b-button>
                  </div>
                  <div class="form-group" v-if="myvideoSrc">
                    <h6>{{ $t("lbl_EMPBE_VideoCover") }} <span class="text-danger">*</span></h6>
                    
                    <div class="blog-box blog-grid text-center product-box" style="border-radius: 0px">
                      <div class="product-img" v-if="myimgSrc">
                        <img class="img-fluid top-radius-blog" :src="myimgSrc" v-if="!showCropTools" alt="" />
                        <div class="product-hover" @click="showCropTools = true">
                          <ul>
                            <li><i class="fa fa-pencil"></i></li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div class="img-container form-group" v-show="showCropTools || !myimgSrc">
                      <!-- <input class="form-control" type="file" accept="image/*" @change="setImage"
                                                ref="fileupload" /> -->
                      <b-form-file class="mb-2" @change="setImage" accept="image/*" ref="fileupload"
                        :placeholder="$t('lbl_EMPBE_InputFile_Placeholder')"
                        :browse-text="$t('lbl_EMPBE_InputFile_BrowseText')"
                        :no-drop-placeholder="$t('lbl_EMPBE_InputFile_NoDropPlaceholder')"
                        :drop-placeholder="$t('lbl_EMPBE_InputFile_DropPlaceholder')"></b-form-file>

                      <vue-cropper ref="cropper" :guides="true" :view-mode="viewmodeselected" drag-mode="crop"
                        :aspectRatio="aspectRatioselected" :auto-crop-area="1" :min-container-width="673"
                        :min-container-height="500" :background="true" :rotatable="true" :movable="true" :src="myimgSrc"
                        alt="Source Image" :ready="ready" :crop="cropImage"
                        :img-style="{ width: myverticalCover?'500px':'800px', height: myverticalCover?'800':'500px' }" v-show="showCropTools"
                        :containerStyle="{ 'max-height': '600px' }">
                      </vue-cropper>
                      <div class="row img-cropper m-t-15" v-show="showCropTools">
                        <div class="col-xl-12 col-md-12 docs-buttons">
                          <b-button-group>
                            <b-button variant="outline-primary" v-on:click="zoominImage"><span
                                class="fa fa-search-plus"></span>
                            </b-button>
                            <b-button variant="outline-primary" v-on:click="zoomoutImage" class="br-right"><span
                                class="fa fa-search-minus"></span></b-button>
                          </b-button-group>
                          <!-- <b-button-group>
                            <b-button
                              variant="outline-primary"
                              v-on:click="moveImageLeft"
                            >
                              <span class="fa fa-arrow-left"></span>
                            </b-button>
                            <b-button
                              variant="outline-primary"
                              v-on:click="moveImageRight"
                            >
                              <span class="fa fa-arrow-right"></span>
                            </b-button>
                            <b-button variant="outline-primary" v-on:click="moveImageUp"
                              ><span class="fa fa-arrow-up"></span>
                            </b-button>
                            <b-button
                              variant="outline-primary"
                              v-on:click="moveImageDown"
                              class="br-right"
                              ><span class="fa fa-arrow-down"></span
                            ></b-button>
                          </b-button-group> -->
                          <b-button-group>
                            <b-button variant="outline-primary" v-on:click="rotateLeft">
                              <span class="fa fa-rotate-left"></span>
                            </b-button>
                            <b-button variant="outline-primary" v-on:click="rotateRight" class="br-right"><span
                                class="fa fa-rotate-right"></span></b-button>
                          </b-button-group>
                          <!-- <b-button-group>
                            <b-button
                              variant="outline-primary"
                              v-on:click="fliphorizontal"
                              ><span class="fa fa-arrows-h"></span>
                            </b-button>
                            <b-button
                              variant="outline-primary"
                              v-on:click="flipvertical"
                              class="br-right"
                              ><span class="fa fa-arrows-v"></span
                            ></b-button>
                          </b-button-group>
                          <b-button-group>
                            <b-button variant="outline-primary" v-on:click="reset">
                              <span class="fa fa-refresh"></span>
                            </b-button>
                          </b-button-group>
                          <b-button-group>
                            <b-button variant="outline-primary" v-on:click="crop">
                              <span class="fa fa-check"></span>
                            </b-button>
                            <b-button
                              variant="outline-primary"
                              v-on:click="cancel"
                              class="br-right"
                              ><span class="fa fa-remove"></span
                            ></b-button>
                          </b-button-group> -->
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="m-b-15">
                    <b-button variant="outline-danger" v-on:click="remove" class="f-right br-right m-l-5">{{
                      $t("lbl_EMPBE_Delete") }}</b-button>
                    <b-button class="f-right br-right" variant="outline-primary" v-on:click="confirm">{{
                      $t("Lbl_PopupForm_Submit") }}</b-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Container-fluid Ends-->
  </div>
</template>

<script>
import VueCropper from "vue-cropperjs";
import "cropperjs/dist/cropper.css";

export default {
  props: [
    "videoId",
    "videoSrc",
    "imageSrc",
    "videoName",
    "UpdateVideo",
    "DeleteVideo",
    "FileName",
    "prevBtn",
    "nextBtn",
    "verticalCover",
  ],
  components: {
    VueCropper,
  },
  data() {
    return {
      videoModel: null,
      myvideoSrc: this.videoSrc,
      myimgSrc: this.imageSrc,
      myvideoName: this.videoName,
      myFileName: this.FileName,
      imgSrc: "",
      imageData: "",
      containerData: "",
      putData: "",
      viewmodeselected: 0,
      cropImg: "",
      aspectRatioselected: this.verticalCover? 0.5625 : 1.7777777777777777,
      zoomImageScale: 1,
      hoverImage: false,
      showCropTools: false,
      uploadScr: "",
      myverticalCover: this.verticalCover
    };
  },
  mounted() { },
  methods: {
    logDuration() {
      console.log("duration", this.$refs.videoPlayer.duration);
    },
    ready() {
      this.containerData = this.$refs.cropper?.getContainerData();
      this.CalZoomScale();
    },
    cropImage() {
      this.imageData = this.$refs.cropper?.getData();
      this.cropImg = this.$refs.cropper?.getCroppedCanvas().toDataURL("image/webp");
    },
    crop() {
      this.imageData = this.$refs.cropper.getData();
      this.cropImg = this.$refs.cropper.getCroppedCanvas().toDataURL("image/webp");
      this.myimgSrc = this.cropImg;
      this.showCropTools = false;
    },
    moveImage() {
      this.$refs.cropper.move(1);
    },
    CalZoomScale() {
      var data = this.$refs.cropper?.getData();
      var containerData = this.$refs.cropper?.getContainerData();
      var scale = containerData?.width / data?.width;
      this.zoomImageScale = scale;
      this.$refs.cropper?.zoomTo(this.zoomImageScale);
    },
    zoominImage() {
      this.zoomImageScale += 0.1;
      this.$refs.cropper.zoomTo(this.zoomImageScale);
    },
    zoomoutImage() {
      this.zoomImageScale -= 0.1;
      this.$refs.cropper.zoomTo(this.zoomImageScale);
    },
    zoom100() {
      this.$refs.cropper.zoomTo(1);
    },
    moveImageLeft() {
      this.$refs.cropper.move(-10, 0);
    },
    moveImageRight() {
      this.$refs.cropper.move(10, 0);
    },
    moveImageUp() {
      this.$refs.cropper.move(0, 10);
    },
    moveImageDown() {
      this.$refs.cropper.move(0, -10);
    },
    moveImageTo() {
      this.$refs.cropper.moveTo(0);
    },
    rotateLeft() {
      this.$refs.cropper.rotate(-90);
    },
    rotateRight() {
      this.$refs.cropper.rotate(90);
    },
    rotate180() {
      this.$refs.cropper.rotateTo(180);
    },
    fliphorizontal() {
      if (this.imageData.scaleX === 1) {
        this.$refs.cropper.scale(-1, 1);
      } else {
        this.$refs.cropper.scale(1, 1);
      }
    },
    flipvertical() {
      if (this.imageData.scaleY === 1) {
        this.$refs.cropper.scale(1, -1);
      } else {
        this.$refs.cropper.scale(1, 1);
      }
    },
    scaleImage() {
      this.$refs.cropper.scale(-2, -1);
    },
    clear() {
      this.$refs.cropper.clear();
    },
    cancel() {
      this.reset();
      this.showCropTools = false;
    },
    disable() {
      this.$refs.cropper.disable();
    },
    enable() {
      this.$refs.cropper.enable();
    },
    reset() {
      if (this.$refs.cropper) {
        this.$refs.cropper.reset();
      }
    },
    destroy() {
      this.$refs.cropper.destroy();
    },
    getCroppedCanvas() {
      this.$refs.getCroppedCanvasModal.show();
    },
    getCroppedCanvas4096() {
      this.$refs.getCroppedCanvas4096.show();
    },
    getCroppedCanvas16090() {
      this.$refs.getCroppedCanvas16090.show();
    },
    getCroppedCanvas320180() {
      this.$refs.getCroppedCanvas320180.show();
    },
    getCropperdata() {
      var data = this.$refs.cropper.getData();
      this.putData =
        '{"x":' +
        data.x +
        ',"y":' +
        data.y +
        ',"width":' +
        data.width +
        ',"height":' +
        data.height +
        ',"rotate":' +
        data.rotate +
        ',"scaleX":' +
        data.scaleX +
        ',"scaleY":' +
        data.scaleY +
        "}";
    },
    getContainerdata() {
      var data = this.$refs.cropper.getContainerData();
      this.putData = '{"width":' + data.width + ',"height":' + data.height + "}";
    },
    getImagedata() {
      var data = this.$refs.cropper.getImageData();
      this.putData =
        '{"naturalWidth":' +
        data.naturalWidth +
        ',"naturalHeight":' +
        data.naturalHeight +
        ',"aspectRatio":' +
        data.aspectRatio +
        ',"width":' +
        data.width +
        ',"height":' +
        data.height +
        ',"left":' +
        data.left +
        ',"top":' +
        data.top +
        "}";
    },
    getCanvasData() {
      var data = this.$refs.cropper.getCanvasData();
      this.putData =
        '{"left":' +
        data.left +
        ',"top":' +
        data.top +
        ',"width":' +
        data.width +
        ',"height":' +
        data.height +
        ',"naturalWidth":' +
        data.naturalWidth +
        ',"naturalHeight":' +
        data.naturalHeight +
        "}";
    },
    getCropBoxData() {
      var data = this.$refs.cropper.getCropBoxData();
      this.putData =
        '{"left":' +
        data.left +
        ',"top":' +
        data.top +
        ',"width":' +
        data.width +
        ',"height":' +
        data.height +
        "}";
    },
    setImage(e) {
      const file = e.target.files[0];
      if (file.type.indexOf("image/") === -1) {
        alert(this.$t("lbl_EMPBE_PleaseSelectImage"));
        return;
      }
      if (typeof FileReader === "function") {
        const reader = new FileReader();
        reader.onload = (event) => {
          this.imgSrc = event.target.result;
          // rebuild cropperjs with the updated source
          this.showCropTools = true;
          this.$refs.cropper.replace(event.target.result);
          this.$refs.fileupload.value = null;
        };
        reader.readAsDataURL(file);
      } else {
        alert(this.$t("lbl_EMPBE_FileReaderNotSupport"));
      }
    },
    confirm() {
      if (this.showCropTools) {
        this.crop();
      }
      if (this.myvideoName == undefined) this.myvideoName = "";
      this.UpdateVideo(
        this.videoId,
        this.myvideoSrc,
        this.myimgSrc,
        this.myvideoName,
        this.myFileName
      );
      if (this.videoId == 0) {
        this.myvideoSrc = "";
        this.myimgSrc = "";
        this.myvideoName = "";
        this.myFileName = "";
      }
      this.videoModel = null;
    },
    remove() {
      this.videoModel = null;
      this.myvideoSrc = "";
      if (this.videoId != 0) {
        this.DeleteVideo(this.videoId);
      } else {
        this.cancel();
      }
    },
    handleFileUpload(event) {
      this.file = event.target.files[0];
      if (this.file.size > 100 * 1024 * 1024) {
        this.$nextTick(() => {
          this.videoModel = null;
          this.myvideoSrc = "";
        });
        this.$swal({
          text: this.$t("lbl_EMPBE_VideoMaxFileSizeReached"),
          showCancelButton: false,
        });
        return;
      } //100MB
      this.myFileName = this.file.name;
      this.previewVideo();
      this.$refs.videoupload.value = null;
    },
    previewVideo() {
      var that = this;
      var video = this.$refs.videoPlayer;
      var reader = new FileReader();

      reader.readAsDataURL(this.file);
      reader.addEventListener("load", function () {
        video.src = reader.result;
        that.myvideoSrc = video.src;
      });
      video.addEventListener('loadeddata', function() {
        setTimeout(()=>{
          that.capture();
        },100);
      }, false);
    },
    capture() {
      var videoCanvas = document.createElement("canvas");

      var video = this.$refs.videoPlayer;

      videoCanvas.height = video.videoHeight;
      videoCanvas.width = video.videoWidth;
      videoCanvas.getContext("2d").drawImage(video, 0, 0);

      // rebuild cropperjs with the updated source
      this.imgSrc = videoCanvas.toDataURL("image/webp");
      this.showCropTools = true;
      this.$refs.cropper.replace(this.imgSrc);
      this.$refs.videoupload.value = null;
      this.$refs.fileupload.value = null;
    },
  },
};
</script>
